<template>
  <div id="app">
    <router-view />
    <div class="update-mask" v-if="need_updating">
      <p>软件更新</p>
      <p>进度：{{ progress }}%</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: "App",
  computed: {
    ...mapState("app", ["need_updating", "progress"]),
  },
  mounted() {
    if (process.env.VUE_APP_IS_SOFTWARE == 'true')
      this.onSoftWareUpdate()
  },
  methods: {
    ...mapMutations("app", ["SET_NEED_UPDATE", "SET_UPDATE_PROGRESS"]),
    onSoftWareUpdate() {
      const ipcRenderer = require("electron").ipcRenderer;
      //0.无需更新 1.开始检查更新 2.检查更新出错 3.需要更新 4.更新下载中 5.更新下载完成
      ipcRenderer.on("softUpdateEvent", (event, arg) => {
        console.log(arg);
        if (arg.action === "checking-for-update") {
          // this.$store.dispatch("setSoftUpdateStatus", 1);
        } else if (arg.action === "error") {
          // this.$store.dispatch("setSoftUpdateStatus", 2);
          this.SET_NEED_UPDATE(false);
        } else if (arg.action === "update-available") {
          this.SET_NEED_UPDATE(true);
          // this.$store.dispatch("setSoftUpdateStatus", 4);
        } else if (arg.action === "update-not-available") {
          // this.$store.dispatch("setSoftUpdateStatus", 0);
          this.SET_NEED_UPDATE(false);
        }
        else if (arg.action == 'download-progress') {
          const progress = (arg?.progress?.percent || 0).toFixed(2);
          this.SET_UPDATE_PROGRESS(progress);
          if (+progress == 100) {
            this.SET_NEED_UPDATE(false);
          }
        }
        else if (arg.action === "update-downloaded") {
          this.$confirm(
            `新版本 <b>${arg.info.version}</b> 已就绪，是否立即安装？<br/><br/>更新内容：${arg.info.releaseNotes}<br/>更新日期：${arg.info.releaseDate}`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              ipcRenderer.send("quitAndInstall");
            })
            .catch(() => { });
          this.SET_NEED_UPDATE(false);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#app {
  position: relative;
}

.update-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 32px;

  p {
    margin: 0;
    margin-bottom: 20px;
  }
}
</style>
